<template lang="pug">
  .product-ingredients.details(:class="{ open: isOpen }")
    button.toggle-button.summary.btn-reset.full-width.xs-f-small.lg-f-medium.max-at-tweak(type="button" @click="toggle" :aria-label="buttonLabel")
      span.title.upper.xs-f-small.lg-f-medium.max-at-tweak.non-focusable.pt-em-0-75.pb-em-0-75.p-8-left.p-8-right(tabindex="-1" ref="returnFocus") ingredients

    .ingredients-wrap(v-if="!displayAsModal" :aria-hidden="!isOpen")
      ProductIngredientsDetails(v-bind:product="product")

</template>

<script>
  import { mapActions } from 'vuex';
  import ProductIngredientsDetails from './ProductIngredientsDetails';

  export default {
    name: 'ProductIngredients',

    components: {
      ProductIngredientsDetails,
    },

    props: {
      product: {
        type: Object,
        required: true
      },
    },

    data: function() {
      return {
        isOpen: false,
        trackEventFired: false,
      }
    },

    computed: {
      buttonLabel() {
        return this.isOpen? 'collapse ingredients': 'expand ingredients';
      },

      displayAsModal() {
        return this.$root.windowData.breakpoint === 'mobile';
      }
    },

    methods: {
      ...mapActions('pdp', ['openProductIngredientsModal']),

      toggle() {
        if (!this.trackEventFired) {
          this.trackToggle();
        }

        if (this.displayAsModal) {
          this.openProductIngredientsModal({ 
            props: {
              product: this.product
            },
            returnFocusElement: this.$refs.returnFocus
          }); 
        } else {
          this.isOpen = !this.isOpen;
        }
      },

      trackToggle() {
        try {
          this.trackEvent('Ingredients Section Toggled', {"product_name": this.product.name, "product_code": this.product.code, "product_id": this.product.id });
          this.trackEventFired = true;
        } catch (e) {}
      }
    }
  };
</script>

<style scoped lang="stylus">
  .product-ingredients
    .toggle-button
      position relative
      text-align left
        
    .ingredients-wrap
      max-height 0
      transition(max-height 300ms ease-in-out)
      overflow hidden
        
    &.open
      .ingredients-wrap
        max-height 120em
        
    @media mq-mobile
      .toggle-button
        &:after
          content icon-caret-right
          font-family fontello
          position absolute
          top 0.75em
          right 5%
    
    @media mq-tablet-plus
      .toggle-button
        .non-focusable
          &:before
            content icon-pos
            font-family fontello
            display inline-block
            margin-right 1em
            
      &.open
        .toggle-button
          .non-focusable
            &:before
              content icon-neg
          
</style>
